import * as companyActionTypes from '../types/Company';
import * as companyValidator from './Validators/CompanyValidator';
import * as errorActions from './Error';
import * as apiCalls from '../api/ApiCalls';
import * as modalActions from './Modal';
import {initDataBySelectedCompany, initDataBySelectedCompanyForPurchaseAddress} from './Customer';
import {addPurchaseAddressToPosition} from './ComplaintPosition';

export function changeSelectedRow(company) {
    return {
        type: companyActionTypes.COMPANY_CHANGE_SELECTED_ROW,
        payload: company
    };
}

export function changeTablePage(page) {
    return {
        type: companyActionTypes.COMPANY_CHANGE_TABLE_PAGE,
        payload: page
    };
}

export function changeTextForSearching(text) {
    return {
        type: companyActionTypes.COMPANY_CHANGE_TEXT_FOR_SEARCHING,
        payload: text
    };
}

export function searchCompaniesByTax(taxId) {
    return async (dispatch) => {
        try {
            dispatch(errorActions.clearError());
            companyValidator.validateTaxValue(taxId);
        } 
        catch (error) {
            return dispatch(errorActions.throwNewError("Błąd walidacji",error.message));
        }
            try {
                dispatch(searchCompaniesByTaxRequest());
                dispatch(errorActions.clearError());
                const response = await apiCalls.GetCompaniesByTax(taxId);
                const result =  await response.json();
                if(response.status===200) {
                    return dispatch(searchCompaniesByTaxSuccess(result));
                }
                else{
                    return dispatch(errorActions.throwNewError("Błąd pobierania danych",result.exceptionMessage));
                }
            } catch (fetchError) {
                return dispatch(errorActions.throwNewError("Błąd pobierania danych",fetchError.message));
            }
    };
}

export function searchCompaniesByText(text) {
    return async (dispatch) => {
            try {
                dispatch(searchCompaniesByTextRequest());
                dispatch(errorActions.clearError());
                const response = await apiCalls.GetCompaniesByText(text);
                const result =  await response.json();
                if(response.status===200) {
                    return dispatch(searchCompaniesByTextSuccess(result));
                }
                else{
                    return dispatch(errorActions.throwNewError("Błąd pobierania danych",result.exceptionMessage));
                }
            } catch (fetchError) {
                return dispatch(errorActions.throwNewError("Błąd pobierania danych",fetchError.message));
            }
    };
}

function searchCompaniesByTextRequest() {
    return {
        type: companyActionTypes.COMPANY_SEARCH_COMPANIES_BY_TEXT_REQUEST
    };
}

function searchCompaniesByTextSuccess(companies) {
    return {
        type: companyActionTypes.COMPANY_SEARCH_COMPANIES_BY_TEXT_SUCCESS,
        payload: companies
    };
}

export function ConfirmModal(selectedCompany) {
    return (dispatch) => {
        try {
            companyValidator.validateSelectedCompany(selectedCompany);
            dispatch(initDataBySelectedCompany(selectedCompany));
            dispatch(modalActions.hideModal());
        } catch (error) {
            dispatch(errorActions.throwNewError("Błąd!",error.message));
        }
    };
}

export function ConfirmPurchaseAddressModal(selectedCompany) {
    return (dispatch) => {
        try {
            companyValidator.validateSelectedCompany(selectedCompany);
            dispatch(initDataBySelectedCompanyForPurchaseAddress(selectedCompany));
            dispatch(addPurchaseAddressToPosition(selectedCompany))

            dispatch(modalActions.hideModal());
        } catch (error) {
            dispatch(errorActions.throwNewError("Błąd!",error.message));
        }
    };
}

function searchCompaniesByTaxRequest() {
    return {
        type: companyActionTypes.COMPANY_SEARCH_COMPANIES_BY_TAX_REQUEST
    };
}

function searchCompaniesByTaxSuccess(companies) {
    return {
        type: companyActionTypes.COMPANY_SEARCH_COMPANIES_BY_TAX_SUCCESS,
        payload: companies
    };
}


// WEBPACK FOOTER //
// ./src/actions/Company.js